import { ref, onMounted, onUnmounted } from 'vue';

export function useScreenSize() {
  const screenHeight = ref(window.innerHeight);
  const screenWidth = ref(window.innerWidth);
  const isPageMini = ref(window.innerWidth < 1920);

  const updateSize = () => {
    screenHeight.value = window.innerHeight;
    screenWidth.value = window.innerWidth;
    isPageMini.value = window.innerWidth < 1920;
  };

  onMounted(() => {
    window.addEventListener('resize', updateSize);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateSize);
  });

  return { screenHeight, screenWidth, isPageMini };
}
